export type BillingPaymentMode = 'test' | 'production';

export interface PlatformBillingSettings {
  paid_payment_enabled: boolean;
  payment_mode: BillingPaymentMode;
  updated_at?: string;
}

export const PLATFORM_TEST_ACCOUNT_EMAIL = 'test@curriculumplanner.com';

/** 테스트 결제 모드에서 「결제하기」 시 입력하는 비밀번호 (환경변수 우선) */
export const PLATFORM_TEST_PAYMENT_PASSWORD_DEFAULT = 'admin1234';

export function getPlatformTestPaymentPassword(): string {
  const fromEnv = (process.env.REACT_APP_TEST_PASSWORD as string | undefined)?.trim();
  return fromEnv || PLATFORM_TEST_PAYMENT_PASSWORD_DEFAULT;
}

export function parseBillingPaymentMode(raw: unknown): BillingPaymentMode {
  return raw === 'production' ? 'production' : 'test';
}

export function isPlatformTestAccountEmail(email: string | null | undefined): boolean {
  return (email ?? '').trim().toLowerCase() === PLATFORM_TEST_ACCOUNT_EMAIL;
}
